<template>
  <CharlaPrivacyPopup></CharlaPrivacyPopup>
  <CharlaTermsPopup></CharlaTermsPopup>
  <CharlaAboutPopup></CharlaAboutPopup>
  <CharlaWorkingPopup></CharlaWorkingPopup>
  <div class="subPage-footer">
    <div class="footer">
      <div class="left-side">
        <div class="social-links">
          <a :href="$t('charlaTg')" target="_blank">
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5387 0.159118L0.591584 5.87106C-0.0501582 6.13706 -0.267213 6.66974 0.436474 6.95883L4.52761 8.16645L14.4194 2.48816C14.9596 2.13169 15.5125 2.22674 15.0367 2.61889L6.54093 9.76377L6.27406 12.7875C6.52125 13.2543 6.97385 13.2565 7.26255 13.0245L9.61303 10.9587L13.6386 13.7586C14.5736 14.2727 15.0823 13.9409 15.2835 12.9986L17.9239 1.3857C18.198 0.22578 17.7305 -0.285295 16.5387 0.159118Z" fill="white" />
            </svg>
          </a>
<!--          <a href="https://wa.me/79856108675" target="_blank">-->
<!--            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M9.00001 0C13.9707 0 18 4.0293 18 8.99999C18 13.9707 13.9707 18 9.00001 18C7.40951 18.0026 5.847 17.5816 4.47301 16.7805L0.00361266 18L1.22041 13.5288C0.418596 12.1544 -0.00264454 10.5912 1.24922e-05 8.99999C1.24922e-05 4.0293 4.02931 0 9.00001 0ZM5.93281 4.77L5.75281 4.7772C5.63628 4.78429 5.52239 4.81491 5.41801 4.8672C5.32038 4.92248 5.23126 4.9916 5.15341 5.0724C5.04541 5.1741 4.98421 5.2623 4.91851 5.3478C4.58562 5.78061 4.40638 6.31198 4.40911 6.858C4.41091 7.299 4.52611 7.72829 4.70611 8.12969C5.07421 8.94149 5.67991 9.80099 6.47911 10.5975C6.67171 10.7892 6.86071 10.9818 7.06411 11.1609C8.05716 12.0352 9.24053 12.6657 10.5201 13.0023L11.0313 13.0806C11.1978 13.0896 11.3643 13.077 11.5317 13.0689C11.7938 13.0554 12.0498 12.9844 12.2814 12.861C12.3993 12.8003 12.5143 12.7342 12.6261 12.663C12.6261 12.663 12.6648 12.6378 12.7386 12.582C12.8601 12.492 12.9348 12.4281 13.0356 12.3228C13.1103 12.2454 13.1751 12.1545 13.2246 12.051C13.2948 11.9043 13.365 11.6244 13.3938 11.3913C13.4154 11.2131 13.4091 11.1159 13.4064 11.0556C13.4028 10.9593 13.3227 10.8594 13.2354 10.8171L12.7116 10.5822C12.7116 10.5822 11.9286 10.2411 11.4498 10.0233C11.3997 10.0014 11.346 9.98891 11.2914 9.98639C11.2298 9.98007 11.1676 9.987 11.1089 10.0067C11.0503 10.0264 10.9965 10.0585 10.9512 10.1007C10.9467 10.0989 10.8864 10.1502 10.2357 10.9386C10.1984 10.9888 10.1469 11.0267 10.0879 11.0475C10.0289 11.0684 9.96509 11.0712 9.90451 11.0556C9.84588 11.0399 9.78843 11.02 9.7326 10.9962C9.62101 10.9494 9.58231 10.9314 9.50581 10.899C8.98927 10.6736 8.51103 10.369 8.08831 9.99629C7.97491 9.89729 7.86961 9.78929 7.76161 9.68489C7.40754 9.3458 7.09896 8.9622 6.84361 8.54369L6.79051 8.45819C6.75237 8.40074 6.72153 8.33877 6.69871 8.27369C6.66451 8.14139 6.75361 8.03519 6.75361 8.03519C6.75361 8.03519 6.97231 7.79579 7.07401 7.66619C7.17301 7.54019 7.25671 7.4178 7.31071 7.3305C7.41691 7.1595 7.45021 6.984 7.39441 6.8481C7.14241 6.2325 6.88141 5.6196 6.61321 5.0112C6.56011 4.8906 6.40261 4.8042 6.25951 4.7871C6.21091 4.7817 6.16231 4.7763 6.11371 4.7727C5.99284 4.76669 5.87173 4.76789 5.75101 4.7763L5.93191 4.7691L5.93281 4.77Z" fill="white" />-->
<!--            </svg>-->
<!--          </a>-->
        </div>
        <div class="copyright">© 2024. Charla</div>
      </div>
      <div class="links">
        <div @click="setAboutState(true)">{{ $t("subPagesUI.link1") }}</div>
        <a href="/privacy-policy" v-if="!isPPPage">{{ $t("subPagesUI.link2") }}</a>
        <a href="/terms-of-use" v-if="!isTOUPage">{{ $t("subPagesUI.link4") }}</a>
        <a href="/public-offer" v-if="!isPOPage">{{ $t("subPagesUI.link3") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import CharlaAboutPopup from "@/components/CharlaAboutPopup.vue";
import CharlaTermsPopup from "@/components/CharlaTermsPopup.vue";
import CharlaPrivacyPopup from "@/components/CharlaPrivacyPopup.vue";
import CharlaWorkingPopup from "@/components/CharlaWorkingPopup.vue";
import {mapActions} from "vuex";

export default ({
  name: "subPageFooter",
  data() {
    return {
      isPPPage: false,
      isTOUPage: false,
      isPOPage: false
    };
  },
  components:{
    CharlaAboutPopup,
    CharlaTermsPopup,
    CharlaPrivacyPopup,
    CharlaWorkingPopup
  },
  methods: {
    ...mapActions(['setPrivacyState', 'setTermsState', 'setAboutState', 'setWorkingPopup']),
  },
  created() {
    this.isPPPage = window.location.pathname.includes('privacy-policy');
    this.isTOUPage = window.location.pathname.includes('terms-of-use');
    this.isPOPage = window.location.pathname.includes('public-offer');
  },
})
</script>

<style scoped lang="sass">
.footer
  display: flex
  align-items: center
  justify-content: space-between
  margin-top: 64px
.left-side
  display: flex
  align-items: center
  gap: 32px
.social-links
  display: flex
  align-items: center
  gap: 8px
  a
    display: flex
    align-items: center
    justify-content: center
    width: 40px
    height: 40px
    background: #000
    border-radius: 50%
    transition: .3s ease
    &:hover
      background: #B561F6
.copyright
  font-size: 12px
  color: #000
.links
  display: flex
  align-items: center
  gap: 32px
  div, a
    display: flex
    align-items: center
    gap: 8px
    font-size: 12px
    color: #000
    text-decoration: none
    transition: .3s ease
    cursor: pointer
    &:before
      content: ''
      background: url("@/assets/img/purple-arrow.svg") no-repeat center/cover
      width: 16px
      height: 16px
      flex: none
    &:hover
      color: #B561F6
@media screen and (max-width: 790px)
  .footer
    flex-direction: column
    gap: 24px
  .left-side
    order: 1
@media screen and (max-width: 660px)
  .links
    flex-direction: column
    margin: 50px 0 24px 0
</style>